<template>
  <page-header :main-title="pageHeader">
    <template #tabs>
      <div class="d-flex mt-5">
        <router-link
          v-if="showGainApiFilesScheduledTab"
          v-slot="{ isActive }"
          :to="{ name: 'GainScheduledApiImportFiles' }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('scheduledApiFilesGain') }}</h4>
          </base-tab>
        </router-link>
        <router-link
          v-if="isGainEngagement"
          v-slot="{ isActive }"
          :to="{ name: 'GainImportFiles' }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('filesGain') }}</h4>
          </base-tab>
        </router-link>
        <router-link
          v-if="isGainEngagement"
          v-slot="{ isActive }"
          :to="{ name: 'GainImportTables' }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('tablesGain') }}</h4>
          </base-tab>
        </router-link>
        <router-link
          v-if="importStorageExists"
          v-slot="{ isActive }"
          :to="{
            name: 'ImportFolders',
            params: { storagePurpose: 'import', path: [] }
          }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('folders') }}</h4>
          </base-tab>
        </router-link>
        <router-link
          v-if="showPipelinePages"
          v-slot="{ isActive }"
          :to="{ name: 'ImportMonitor' }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('monitor') }}</h4>
          </base-tab>
        </router-link>
        <div class="horizontal-line mt-2">
          <hr />
        </div>
      </div>
    </template>
    <template #subheader>
      <div class="mt-3">
        <h4
          v-if="routerName == 'GainScheduledApiImportFiles'"
          class="subtitle-2"
        >
          {{ $t('gainScheduledApiImportFilesDesc') }}
        </h4>
        <h4 v-else-if="routerName == 'GainImportFiles'" class="subtitle-2">
          {{ $t('gainImportFilesDesc') }}
        </h4>
        <h4 v-else-if="routerName == 'GainImportTables'" class="subtitle-2">
          {{ $t('gainImportTablesDesc') }}
        </h4>
      </div>
    </template>
  </page-header>
  <div class="mt-6">
    <router-view />
  </div>
</template>
<script lang="ts">
import PageHeader from '@/components/misc/PageHeader.vue';
import BaseTab from '@/components/tabs/BaseTab.vue';
import i18n from '@/i18n';
import { computed, ComputedRef, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
  ApiName,
  ApiConnectionConfiguration
} from '@etp/etp-gain-bff-client/axios';
import config from '@/config/config';

export default {
  name: 'ImportOverview',
  components: {
    PageHeader,
    BaseTab
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    let routerName = ref(router.currentRoute.value.name);

    const pageHeader: ComputedRef<string> = computed(
      () => store.getters['home/getPageHeader']
    );

    const isGainEngagement: ComputedRef<boolean> = computed(
      () => store.getters['home/isGainEngagement']
    );
    const showStoragePages: ComputedRef<boolean> = computed(
      () => store.getters['home/showStoragePages']
    );
    const importStorageExists: ComputedRef<boolean> = computed(
      () => store.getters['storage/importStorageExists']
    );
    const showPipelinePages: ComputedRef<boolean> = computed(
      () => store.getters['home/showPipelinePages']
    );

    const gainApiConnectionConfigurations: ComputedRef<
      Array<ApiConnectionConfiguration>
    > = computed(
      () => store.getters['engagements/getApiConnectionConfigurations']
    );

    const showGainApiFilesScheduledTab: ComputedRef<boolean> = computed(() => {
      if (!isGainEngagement.value) return false;
      return (
        config.features.showGainApiFeatures &&
        gainApiConnectionConfigurations.value.some(
          connection => connection.apiName === ApiName.Etrade
        )
      );
    });

    onMounted(async () => {
      if (!showStoragePages.value) return router.push({ name: 'Overview' });
      if (routerName.value == 'Import') {
        if (importStorageExists.value) {
          return router.push({
            name: 'ImportFolders',
            params: { storagePurpose: 'import', path: [] }
          });
        } else {
          return router.push({ name: 'ImportMonitor' });
        }
      }
      if (routerName.value !== 'ImportFolders') {
        store.commit('home/SET_PAGE_HEADER', i18n.global.t('import'));
      }

      if (
        config.cloudProvider.toLowerCase() === 'aws' &&
        config.features.showGainApiFeatures
      ) {
        const engagement = store.getters['home/getCurrentEngagement'];
        await store.dispatch(
          'engagements/fetchApiConnectionConfigurations',
          engagement.id
        );
      }
    });

    return {
      importStorageExists,
      isGainEngagement,
      pageHeader,
      routerName,
      showPipelinePages,
      showGainApiFilesScheduledTab
    };
  }
};
</script>
<style lang="scss" scoped></style>
